import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const formatBillName = (fileName: string): string => {
  return fileName
    .replace(/-/g, " ") // Replace hyphens with spaces
    .replace(/(\d+)/g, " $1 ") // Ensure numbers are spaced properly
    .replace(/\.\w+$/, "") // Remove the file extension
    .replace(/\s+/g, " ") // Remove extra spaces
    .trim() // Trim any leading or trailing spaces
    .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
};
